import React from 'react';
import { Autocomplete, AutocompleteProps, TextField, TextFieldProps } from '@mui/material';
import _ from 'lodash';

type StatusFieldProps<T> = Omit<AutocompleteProps<T, false, false, false>, 'options' | 'renderInput'> & {
  options: T[];
  slotProps?: {
    input?: Partial<TextFieldProps>;
  };
  renderOptionNode?: (option: T) => React.ReactNode;
  getBackgroundColor?: (value: T) => string | undefined;
};

export default function StatusField<T>({ options, renderOptionNode, getBackgroundColor, ...rest }: StatusFieldProps<T>) {
  const background = rest.value && getBackgroundColor ? `${getBackgroundColor(rest.value)}30` : undefined;

  const sx = { background, ...rest.slotProps?.input?.sx };

  return (
    <Autocomplete<T, false, false, false>
      {...rest}
      options={options}
      getOptionLabel={(option) => _.startCase(String(option))}
      renderOption={(props, option) => <li {...props}>{renderOptionNode ? renderOptionNode(option) : _.startCase(String(option))}</li>}
      renderInput={(params) => <TextField {...params} {...rest.slotProps?.input} sx={sx} />}
    />
  );
}
